export interface VerifiedSender {
  id: string
  nickname: string
  fromEmail: string
  fromName: string
  replyToEmail: string
  replyToName: string | null
  address: string
  address2: string | null
  city: string
  state: string | null
  zip: string | null
  country: string
  verified: boolean
  locked: boolean
  createdAt: string | null
  updatedAt: string | null
}

export interface SmsSender {
  id: string
  method: 'SMS'
  nickname: string
  phoneNumber: string
  inboundApp: 'schedule' | null
  verified: boolean
  verifiedAt: string | null
  active: boolean
  isDefault: boolean
  locked: boolean
  createdAt: string
  updatedAt: string
}

export type Sender = VerifiedSender | SmsSender
export type SenderMethod = 'EMAIL' | 'SMS'
export const isSmsSender = (sender: Sender): sender is SmsSender => 'method' in sender && sender.method === 'SMS'
export const senderAddress = (sender: Sender) => (isSmsSender(sender) ? sender.phoneNumber : sender.fromEmail)
export const senderMethod = (sender: Sender): SenderMethod => (isSmsSender(sender) ? 'SMS' : 'EMAIL')

export interface CreateEmailSenderPayload {
  nickname: string
  fromEmail: string
  fromName: string
  replyToEmail: string
  replyToName?: string | null
}
export type CreateSenderPayload =
  | CreateEmailSenderPayload
  | {
      method: 'SMS'
      nickname: string
      phoneNumber: string
      inboundApp?: 'schedule' | null
    }

export interface UpdateEmailSenderPayload {
  nickname?: string
  fromEmail?: string
  fromName?: string
  replyToEmail?: string
  replyToName?: string | null
}
export type UpdateSenderPayload =
  | UpdateEmailSenderPayload
  | {
      nickname?: string
      inboundApp?: 'schedule' | null
      active?: boolean
    }

export interface SenderAddressDefaults {
  address: string
  address2: string | null
  city: string
  state: string | null
  zip: string | null
  country: string
}

export interface SenderAddressDefaultsResponse {
  defaults: SenderAddressDefaults | null
  missing: string[]
}
